export default __webpack_public_path__ + "static/media/cards.c2d27c55.svg";